import React from 'react';
import { IAuditoriaCaixaFornecedoresResultado } from '../interfaces/IAuditoriaCaixaFornecedores';

interface Props {
  resultado: IAuditoriaCaixaFornecedoresResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const cls =
    status === 'ERRO'   ? 'badge-light-danger' :
    status === 'ALERTA' ? 'badge-light-warning' :
    status === 'AVISO'  ? 'badge-light-warning' :
                          'badge-light-success';
  return <span className={`badge ${cls}`}>{status}</span>;
};

const AuditoriaResumoCaixaFornecedores: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  if (resultado.status === 'CONCILIADO' && resultado.itens.length === 0) return null;

  const top5 = [...resultado.itens]
    .sort((a, b) => b.valor - a.valor)
    .slice(0, 5);

  return (
    <div className='card card-custom card-stretch mb-5'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-4 mb-1'>
            Pagamentos a Fornecedores via Caixa/Espécie
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Lei 9.430/96 Art. 3º · RIR/2018 Art. 302 · Lei 9.430/96 Art. 44 I · CPC 00 (R2)
          </span>
        </h3>
        <div className='card-toolbar'>
          <button className='btn btn-sm btn-light-primary' onClick={onVerDetalhe}>
            Ver Detalhes
          </button>
        </div>
      </div>

      <div className='card-body pt-3'>
        <div className='row mb-5'>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-8'>Erros (&gt; R$ 2.000)</div>
          </div>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-8'>Alertas (R$ 500–2.000)</div>
          </div>
          <div className='col-3 text-center border-end'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-8'>Avisos (≤ R$ 500)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>
              {formatCurrency(resultado.passivoTributarioTotal)}
            </div>
            <div className='text-muted fs-8'>Passivo Estimado</div>
          </div>
        </div>

        {top5.length > 0 && (
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Empresa</th>
                  <th>Data</th>
                  <th>Histórico</th>
                  <th className='text-end'>Valor</th>
                  <th className='text-center'>Status</th>
                </tr>
              </thead>
              <tbody>
                {top5.map((item, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{item.empresaNome}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.cnpj}</span>
                    </td>
                    <td className='fw-bold'>{item.dataLancamento}</td>
                    <td className='text-muted fs-8' style={{ maxWidth: '200px', wordBreak: 'break-word' }}>
                      {item.fornecedorHistorico}
                    </td>
                    <td className='text-end fw-bold'>{formatCurrency(item.valor)}</td>
                    <td className='text-center'><StatusBadge status={item.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditoriaResumoCaixaFornecedores;
